import { translate } from "app/filters/i18nFilter";
import { EMPTY_PROJECT_LIST_SRC } from "app/pages/activation/components/ProjectsList/constants";
import { statesDataAutomation } from "app/pages/activation/components/ProjectsList/dataAutomationKeys";
import * as SC from "app/pages/activation/components/ProjectsList/States/styles";
import {
    EMPTY_PROJECT_LIST_DESCRIPTION,
    EMPTY_PROJECT_LIST_TITLE,
} from "app/pages/activation/components/ProjectsList/States/texts";
import { AssetsService } from "app/services/AssetsService";

export const EmptyFilteredResult = () => (
    <SC.Container data-automation={statesDataAutomation.empty}>
        <SC.EmptyImage src={AssetsService.assetUrl(EMPTY_PROJECT_LIST_SRC)} />
        <SC.Content>
            <SC.Title>{translate(EMPTY_PROJECT_LIST_TITLE)}</SC.Title>
            <SC.Description>{translate(EMPTY_PROJECT_LIST_DESCRIPTION)}</SC.Description>
        </SC.Content>
    </SC.Container>
);
